export const isDevelopment = () => process.env.NODE_ENV === 'development';
export const isElectron = () => process.env.IS_ELECTRON === true;
export const isNotElectron = () => process.env.IS_ELECTRON === false;
export const jwtSecret = () => process.env.JWT_SECRET || '3duc4b0tsup3rs3cr3t';
